import { graphql } from 'react-relay/legacy';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $isClient: Boolean!
        $isAuctionItemsFF: Boolean!
        $fetchInitialHomepage: Boolean!
        $zipCode: String
        $localRecentHistoryList: [LocalRecentHistoryListInputType] = []
        $recentActivityDesignVariant: String = "default"
        $locationItemsCount: Int
        $auctionItemsCount: Int!
        $userType: String!
    ) {
        viewer {
            ...HpSharedLayout_viewer
            homepage(rootId: $homepageId) {
                ...getHomePageMetaContent_homepage @relay(mask: false)
                # necessary to throw error & not cache homepage if no modules return
                modules {
                    __id
                }
            }
        }
    }
`;

const homepageVariables = {
    fetchInitialHomepage: true,
    hasRecentlyViewedItems: false,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    recentlyViewedItemIds: [],
    userIds: [],
    isClient: false,
    isAuctionItemsFF: true,
    countryCode: '',
    zipCode: '',
    locationItemsCount: 0,
    auctionItemsCount: 0,
    userType: '',
};

export { homepageRootQuery, homepageVariables };
